export const TWENTY_EIGHT_DAYS_IN_SECONDS = 60 * 60 * 24 * 28;
export const THIRTY_DAYS_IN_MILLISECONDS = 1000 * 60 * 60 * 24 * 30;
export const THREE_HUNDRED_SIXTY_FIVE_DAYS_IN_SECONDS = 60 * 60 * 24 * 365;
